"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalVariantValue = void 0;
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const getTotalVariantValue = (variant, date) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return variant.order_lines.reduce((acc, cur) => {
        return acc + (0, getOrderLineTotal_1.getOrderLineTotal)(cur, date);
    }, 0);
};
exports.getTotalVariantValue = getTotalVariantValue;
